import { adViewApi } from 'api/adViewApi';
import type { Stripe } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';

import getConfig from 'next/config';
import type { AxiosResponse } from 'axios';

const {
  publicRuntimeConfig: { STRIPE_KEY },
} = getConfig();

interface StripeCheckoutSession {
  sessionId: string;
  connectedStripeAccountId: string;
}

async function callStripeCheckout(
  adId: number,
  selectedQuantity: number,
  phoneNumber?: string,
): Promise<StripeCheckoutSession> {
  const { data }: AxiosResponse<StripeCheckoutSession> =
    await adViewApi.createStripeCheckoutSession(
      adId,
      selectedQuantity,
      {},
      phoneNumber,
    );
  return data;
}

async function createStripeObjectInstance(
  connectedStripeAccountId: string,
): Promise<Stripe | null> {
  const response = await loadStripe(STRIPE_KEY, {
    stripeAccount: connectedStripeAccountId,
  });

  return response;
}

export { callStripeCheckout, createStripeObjectInstance };
